import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet'
import './styles/App.css';

class CategoryList extends Component {
  render() {
    const categories = this.props.categories ? Object.keys(this.props.categories).map((framework_id) => 
      <div className="col-md-4 d-flex align-items-stretch">
        <Link to={`/category/${this.props.categories[framework_id].slug}`} className="model-detail-div box-shadow w-100">
          <h2 className="title">{this.props.categories[framework_id].title}</h2>
          <p className="description" dangerouslySetInnerHTML={{__html: this.props.categories[framework_id].description}}></p>
        </Link>
      </div>
    ) : "";

    return categories ? (
      <div>
      <Helmet>
        <title>Model Zoo - Categories</title>
      </Helmet>

      <h1>Categories</h1>
      <hr/>
      <div className="row">
      {categories}
      </div>
      </div>
    ) : "";
  }
}

export default CategoryList;


// WEBPACK FOOTER //
// ./src/CategoryList.jsx